export * from "modules/DpoContract/hooks/useAcceptDpoContractMutation";
